/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./links.component";
import * as i2 from "./navbar.service";
var styles_LinksComponent = [];
var RenderType_LinksComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_LinksComponent, data: {} });
export { RenderType_LinksComponent as RenderType_LinksComponent };
export function View_LinksComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\n        "])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(-1, null, ["\n    "]))], null, null); }
export function View_LinksComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "links", [], null, null, null, View_LinksComponent_0, RenderType_LinksComponent)), i0.ɵdid(1, 5292032, null, 1, i1.LinksComponent, [i2.NavbarService], null, null), i0.ɵqud(603979776, 1, { links: 1 })], null, null); }
var LinksComponentNgFactory = i0.ɵccf("links", i1.LinksComponent, View_LinksComponent_Host_0, {}, { linkClick: "linkClick" }, ["*"]);
export { LinksComponentNgFactory as LinksComponentNgFactory };



// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/navbars/links.component.ngfactory.js.pre-build-optimizer.js